export default __webpack_public_path__ + "static/engravers-gothic-bd6650c98876f5bd3bee362926f616c5.otf";